<template>
  <div class="layout--signin">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
